import React, { useCallback, useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import TDK from 'components/tdk';
import Layout from 'components/layout';
import { WrapperBanner } from 'components/product/banner';
import MultipleBanner from 'components/product/banner/multiple';
import Advantages from 'components/advantages';
import Contact from 'components/contact';
import { Tabs } from 'antd';
import UseResize from 'utils/hooks/useResize';
import Transition from 'components/transition';
import style from './index.module.scss';
import CdnImage from 'components/image/cdnImage';

const IMG_PATH = 'https://sdk-source.xylink.com/h5/sdk_doc/static/website/advantage/';

const arrowIcon = [
  IMG_PATH + 'c7d33ca5b845dae2a15c09acace7b01e8ca6ea0c5d5aae1dbb1781fed4d5df49.png',
  IMG_PATH + '790fd30bcee8c08029b3666c90609d533f7f4472eee3b0c664d85c21fe07e246.png',
  IMG_PATH + '07898d27ee2cf768d25eaf370041ff2fda9bf48e33c3678bae7a2e24a2c5032f.png',
];
const headerMp4Url = IMG_PATH + '5eabafd0282a29f6f39fb5241927f6f60838e4144f49f18a355a31eacb14eb93.mp4';
const headerGifUrlM = IMG_PATH + 'e27190bb1b7d5498080b715c17f620be34c47173016b7646a839d4d73c514bd5.gif';
const bannerMp4Url = IMG_PATH + '281c18a1953929a627dd0ee7f6c1533aae87c2d3627ad332f69ba10eaa1f7306.mp4';
const bannerGifUrlM = IMG_PATH + 'e6847e9099b71d7a1cee2f00719c507e72c3382817d327e6e8fe38bb3f5741ed.gif';

const advantages = [
  [
    {
      icon: IMG_PATH + '7131df8a6262cad6f51679eca27daa621548334471512d327a70abfbfb17e185.png',
      desc: '自研底层技术\n国产芯片硬件终端\n全面适配信创解决方案',
    },
    {
      icon: IMG_PATH + 'b94224730c61797521d0e01ca27bd49c91bc9c165e2b598c42bb6d2dff59bb69.png',
      desc: '端到端安全加密\n动态一会一密\n支持国密算法',
    },
    {
      icon: IMG_PATH + 'ab65fef905bf9f4cb6cf22e28b0fd9cbf119d1225f2d4c80f80c3da69e13fd22.png',
      desc: '权限分级，运管分离\n确保运维安全有序',
    },
  ],
  [
    {
      icon: IMG_PATH + 'fdb55d42c55c39c073588b8e2305fb40b865212b185dc47dd048e79d6ae7fba1.png',
      desc: '软件定义架构\n全虚拟化平台，与硬件解耦\n可基于任意 IaaS 云底座部署',
    },
    {
      icon: IMG_PATH + 'f38e7c0326153e0485ad6457a2d8acd7720dd0dc6bcda0463edd47fd829dc552.png',
      desc: '可实现视频会议、直播、点播、监控、\n语音、数据等多种形式融合互通',
      mDesc: '可实现视频会议、直播、点播、\n监控、语音、数据等多种形式\n融合互通',
    },
    {
      icon: IMG_PATH + '8730666faf90b25ea1dc8a9a42ae5083e0eab4fc3ff06da3c1223561df85141e.png',
      desc: '按需扩展，灵活高效\n无容量上限制约',
    },
  ],
];

const bannerList = [
  {
    mUrl: IMG_PATH + '5c0f39f70550e7b75be3dc490acd54acb07b6a8e9bdecbc0577e648dfb1d3275.jpg',
    pcUrl: IMG_PATH + '9f15c58f8028d43afeda122c187791f606016f221b4798d237f6d09e89707293.jpg',
    title: '兼容利旧，终端丰富',
    desc: 'AVC+SVC 双引擎，兼容各主流品牌会议室终端，原有设备充分利旧，实现高效提质升级\n提供形态丰富的各种硬件终端、软件客户端及 SDK 智能设备，可满足各类大中小型会议室以及户外等全场景应用需求',
    mDesc: 'AVC+SVC双引擎，兼容各主流品牌会议室终端，\n原有设备充分利旧，实现高效提质升级\n提供形态丰富的各种硬件终端、软件客户端及 SDK 智\n能设备，可满足各类大中小型会议室以及户外等全场景\n应用需求',
  },
  {
    mUrl: IMG_PATH + 'b49ca03261987690369de5b207395c8ec0ad603e4b794a40c6b6e3eb33217052.jpg',
    pcUrl: IMG_PATH + 'f66c102e9515a607439511b97d0642e3b8416d0283a00ebc24b6d2352b859038.jpg',
    title: '多网接入，多云融合',
    desc: '支持政务内外网、行业专网、互联网、4G/5G、卫星网等多网络灵活接入\n提供公有云、私有云、混合专有云等多种部署方案，可针对不同行业需求提供定制化服务',
    mDesc: '支持政务内外网、行业专网、互联网、4G/5G、\n卫星网等多网络灵活接入\n提供公有云、私有云、混合专有云等多种部署方案，\n可针对不同行业需求提供定制化服务',
  },
];

const functions = [
  { title: '人脸识别', img: IMG_PATH + 'c780d53347c467f6f8df7a8bdacd9bb78f28ac794d72506c8f0fefd346ef3949.png' },
  {
    title: '自动签到',
    img: IMG_PATH + '05983c680fb64bd41e39113b7421e63045dda491eab0865d5e317e00693bff90.png',
  },
  {
    title: '电子铭牌',
    img: IMG_PATH + '1f87d6e12a850ecc2d62901ffd9a5008f7b0e2ce20f8616c7ac192b226034755.png',
  },
  {
    title: '通话字幕',
    img: IMG_PATH + 'subtitle.jpg',
  },
  {
    title: '自动生成会议纪要',
    img: IMG_PATH + 'a746dfa6526e5dc08aa3a550c015047cab960802a6b032f03145399c919322e2.png',
  },
];

const bannerDesc = [
  {
    desc: '全平台高可用架构设计，分布式集群部署\n资源池负载均衡、多活热备、多云多活，故障自动迁移，保证运行稳定不中断',
    mDesc: '全平台高可用架构设计，分布式集群部署\n资源池负载均衡、多活热备、多云多活\n故障自动迁移，保证运行稳定不中断',
  },
];

const Advantage = () => {
  const size = UseResize();
  const [activeKey, setActiveKey] = useState(0);
  const container = useRef<HTMLDivElement>(null);
  const stopAct = useRef(false);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const videoRef1 = useRef<HTMLVideoElement>(null);
  const videoRef2 = useRef<HTMLVideoElement>(null);

  const clearTimer = () => {
    timerRef.current && clearInterval(timerRef.current);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const play = () => {
    clearTimer();
    if (stopAct.current) return;
    timerRef.current = setInterval(() => {
      setActiveKey(activeKey => (activeKey + 1) % functions.length);
    }, 2000);
  };

  const onScroll = useCallback(() => {
    const clientScreen = document.documentElement.clientHeight;
    if (container.current) {
      const { top } = container.current.getBoundingClientRect();
      /* 当元素出现在视口当中 */
      if (top < clientScreen) {
        play();
      }
    }
  }, [play]);

  useEffect(() => {
    window.addEventListener('scroll', onScroll, true);
    return () => {
      window.removeEventListener('scroll', onScroll);
      clearTimer();
    };
  }, [onScroll]);

  /* 移动端时 无滚动时 触发动画*/
  useEffect(() => {
    if (!container.current?.scrollTop) {
      onScroll();
    }
  }, [onScroll]);

  //自动播放
  useEffect(() => {
    const video1 = videoRef1.current;
    const video2 = videoRef2.current;

    video1?.play();
    video2?.play();
  }, []);

  return (
    <Layout>
      <TDK pageKey="advantage" />
      <div className={style.container}>
        <video
          className={style['for-pc']}
          autoPlay
          muted
          loop
          src={headerMp4Url}
          webkit-playsinline="true"
          playsInline={true}
          x-webkit-airplay="true"
          x5-video-player-type="h5"
          x5-video-player-fullscreen="true"
          x5-video-ignore-metadata="true"
          preload="auto"
        >
          您的浏览器不支持video
        </video>
        <div className={style['for-mobile']}>
          <CdnImage className={cn(style.mapImg)} src={headerGifUrlM} alt="advantage" />
        </div>
        <div className={style.advantageWrapper}>
          <Advantages title="全面自主，安全可控" advantage={advantages[0]} delay={0.5} className={style.banner} />
          <img className={style.arrowIcon} src={arrowIcon[0]} alt="" />
        </div>
        <WrapperBanner
          bannerInfo={{
            pcUrl: `${IMG_PATH}c2878bd48a890785190dbf7425459ffdb36bbe90e1c4f2f4c26f6d711465f3df.jpg`,
            mUrl: `${IMG_PATH}53da19e04a7893a3034154b0b6a2fb706110ec03112bd96a031035b7580acdba.jpg`,
            classNames: cn(style.banner1, style.banner),
          }}
        >
          <Transition delay={0.5}>
            <p className={style.title}>高可用，稳定可靠</p>
          </Transition>
          <Transition delay={0.7}>
            <p
              className={cn(style.desc)}
              dangerouslySetInnerHTML={{
                __html: `${size.width < 768 ? bannerDesc[0].mDesc : bannerDesc[0].desc}`.replace(/\n/g, '<br>'),
              }}
            ></p>
          </Transition>
          <Transition delay={0.9}>
            <div className={style.items}>
              <div className={style.item}>
                <p className={style.itemTitle}>稳定运营超过</p>
                <p className={style.itemTotal}>
                  70000<span className={style.unit}>小时</span>
                </p>
              </div>
              <div className={style.item}>
                <p className={style.itemTitle}>单客户</p>
                <p className={style.itemTotal}>
                  65000<span className={style.unit}>方并发</span>
                </p>
              </div>
            </div>
          </Transition>
        </WrapperBanner>

        <Advantages title="超融合，适用性强" advantage={advantages[1]} delay={0.5} className={style.banner} />

        <div className={cn(style.technology, style.banner)}>
          <video
            className={style['for-pc']}
            autoPlay
            muted
            loop
            src={bannerMp4Url}
            webkit-playsinline="true"
            playsInline={true}
            x-webkit-airplay="true"
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            x5-video-ignore-metadata="true"
            preload="auto"
          >
            您的浏览器不支持video
          </video>
          <div className={style['for-mobile']}>
            <CdnImage className={cn(style.mapImg)} src={bannerGifUrlM} alt="advantage" />
          </div>

          <div className={style.content}>
            <Transition delay={0.5}>
              <p className={style.title}>技术领先，算法高效</p>
            </Transition>

            <Transition delay={0.8}>
              <p className={cn(style.desc, 'for-pc')}>大规模成熟应用 SVC 柔性编解码算法</p>
              <p className={cn(style.desc, 'for-mobile')}>
                大规模成熟应用 SVC 柔性编解码算法
                <br />
                智能路由架构，相比传统 MCU，
              </p>

              <p className={cn(style.desc, 'for-pc')}>
                智能路由架构，相比传统 MCU，硬件效率提升<span className={style.number}>50</span>倍，延时降低
                <span className={style.number}>
                  80 <sub>%</sub>
                </span>
              </p>
              <p className={cn(style.desc, 'for-mobile')}>
                硬件效率提升<span className={style.number}>50</span>倍，延时降低
                <span className={style.number}>
                  80 <sub>%</sub>
                </span>
              </p>

              <p className={cn(style.desc, 'for-pc')}>无需专网，具有超强抗丢包能力，实现 30% 丢包不花屏，50% 丢包声音清楚连贯</p>
              <p className={cn(style.desc, 'for-mobile')}>
                无需专网，具有超强抗丢包能力，
                <br />
                实现 30% 丢包不花屏，50% 丢包声音清楚连贯
              </p>
            </Transition>
          </div>
        </div>

        {bannerList.map((item: any, index: number) => {
          return <MultipleBanner animate={'fadeIn'} delay={0.5} {...item} key={item.title} type={0} className={cn(style.banner, style.banner2, index === 1 && style.banner3)} />;
        })}

        <div className={cn(style.banner, style.banner6)} ref={container} style={{ backgroundImage: `url(${size.width < 768 ? '' : arrowIcon[2]})` }}>
          <Transition delay={0.5}>
            <p className={style.title}>易管易用，AI 赋能</p>
          </Transition>
          <Transition delay={0.5}>
            <p className={style.desc}>统一入口管理，丰富的会控功能，让管控更高效</p>
          </Transition>
          <div className={style.items}>
            <div className={style.titleWrapper}>
              <Transition delay={0}>
                <p className={style.littleTitle}>丰富的 AI 智能应用</p>
              </Transition>
            </div>
            <Tabs
              tabPosition={size.width < 768 ? 'top' : 'left'}
              animated={size.width < 768 ? true : false}
              className={style.test}
              activeKey={activeKey.toString()}
              onTabClick={(activeKey: string) => {
                stopAct.current = true;
                setActiveKey(Number(activeKey));
                clearTimer();
              }}
            >
              {functions.map((item, index) => (
                <Tabs.TabPane tab={item.title} key={index} className={style.item}>
                  <img src={item.img} alt="" className={style.img} />
                </Tabs.TabPane>
              ))}
            </Tabs>
          </div>
          <img className={cn(style.arrowIcon, 'for-mobile')} src={arrowIcon[1]} alt="" />
        </div>

        <div className={style.banner5}>
          <MultipleBanner
            type={2}
            mUrl={`${IMG_PATH}b6dcca7ae95845559777a8fee4769f75df093a1b4775e6f1a7c118ab8131ac25.jpg`}
            pcUrl={`${IMG_PATH}ed0580099b29ba99caa4aa90629bfcfeca3f223853fc5f33d6e4f98f777d4fa4.jpg`}
            title={'开放赋能，集成简便'}
            desc={`全面开放 API/SDK 能力，为业务赋能与场景创新提供强大的音视频底座支撑\n轻代码开发，方便对接与调试，可有效提升开发效率，确保快速上线`}
            mDesc={`全面开放 API/SDK 能力，\n为业务赋能与场景创新提供强大的音视频底座支撑\n轻代码开发，方便对接与调试，\n可有效提升开发效率，确保快速上线`}
            className={cn(style.banner, style.banner2, style.banner4)}
            delay={0.5}
            animate={'fadeIn'}
          ></MultipleBanner>

          <Contact className={style.contact} btnType={'newBtn'} />
        </div>
      </div>
    </Layout>
  );
};

export default Advantage;
